module.exports = __webpack_public_path__ + "h5/img/noGood.7aec7edd.png";